import React, { useState } from 'react'
import { ButtonRounded, Notification } from 'is24-corecss'
import { useTranslation } from 'react-i18next'
import { IconS24Lightbulb24, IconS24Upload48 } from '@is24/cosma-ui-icons'
import { useAppSelector } from '../../../../app/hooks'
import { InitState } from '../../../../redux/reducers/root/initialState'
import { isEditEntryMode } from '../../../../@types/types'
import { AiDataExtractionUploadModal } from './AiDataExtractionUploadModal'
import { useToastContext } from '../../../../app/toast/toastContext'
import { trackAiDataExtractionBannerClick } from './aiDataExtractionTracking'
import styles from './AiDataExtractionBanner.module.css'

export const AiDataExtractionBanner = () => {
  const { t } = useTranslation()
  const toastContext = useToastContext()
  const entryMode = useAppSelector(
    (state: InitState) => state.insertionFeature.insertionIdentification.metaInformation?.entryMode
  )
  const isAiDataExtractionSupported = useAppSelector(
    (state: InitState) => state.flowFeature.flowInformation.options?.hasAiDataExtractionBanner
  )
  const flowInformation = useAppSelector((state: InitState) => state.flowFeature.flowInformation)
  const isEditFlow = isEditEntryMode(entryMode)
  const [dismissedInSession, setDismissedInSession] = useState(false)
  const [isUploadModalOpen, setIsUploadModalOpen] = useState(false)
  const [extractionApiError, setExtractionApiError] = useState(false)

  if (dismissedInSession || isEditFlow || !isAiDataExtractionSupported) {
    return null
  }

  return (
    <div className='margin-bottom-l' data-testid='ai-data-extraction-banner'>
      <div className={styles.notificationWrapper}>
        <span className={styles.notificationBulb} data-testid='ai-data-extraction-banner-bulb'>
          <IconS24Lightbulb24 />
        </span>
        <Notification
          className={styles.notification}
          title={t('wizard.uploadAiBanner.title')}
          message={t('wizard.uploadAiBanner.message')}
          type={'neutral'}
          variant={'flat'}
          onClose={() => setDismissedInSession(true)}
          actionButton={
            <ButtonRounded
              variant={'filledWeak'}
              endElement={<IconS24Upload48 />}
              onClick={() => {
                trackAiDataExtractionBannerClick(flowInformation, entryMode)
                setIsUploadModalOpen(true)
              }}
            >
              {t('wizard.uploadAiBanner.cta')}
            </ButtonRounded>
          }
        />
      </div>
      <AiDataExtractionUploadModal
        extractionApiError={extractionApiError}
        isOpen={isUploadModalOpen}
        onClearExtractionApiError={() => setExtractionApiError(false)}
        onClose={() => {
          setIsUploadModalOpen(false)
          setExtractionApiError(false)
        }}
        onExtractionFailed={() => {
          setIsUploadModalOpen(true)
          setExtractionApiError(true)
        }}
        onSuccess={() => {
          setExtractionApiError(false)
          toastContext?.addToast({
            headline: t('wizard.uploadAiBanner.toast.headline'),
            message: t('wizard.uploadAiBanner.toast.message'),
            type: 'success',
            timeout: 6000,
            variant: 'elevated',
          })
        }}
      />
    </div>
  )
}
